
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/quicksell-for-clothing",
      function () {
        return require("private-next-pages/quicksell-for-clothing/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/quicksell-for-clothing"])
      });
    }
  